import './about.css';

const About = () => {
  return (
    <section className="about container" id="about">
      <h2>About Me</h2>
      <p>
        Computer Science undergraduate skilled in full-stack development using the MERN stack and backend
        systems, with hands-on experience in Machine Learning through real-world projects and internship work.
        Strong foundation in Data Structures, Algorithms, and system design, with experience building scalable
        web applications and real-time systems. Strong foundation in Data Structures, Algorithms, OOPs,
        and system design.
      </p>
    </section>
  );
};

export default About;